<div
    class="d-flex flex-column align-items-center justify-content-center version-comparison-empty">
    <svg-icon src="assets/images/icon-search.svg"
        class="version-comparison-empty__icon"></svg-icon>
    <span class="version-comparison-empty__title">
        Selecione versão para comparação
    </span>
    <span class="version-comparison-empty__description">
        As diferenças serão destacadas para facilitar a análise
        das alterações.
    </span>
</div>
